import React, { FC, useState } from 'react'
import { AxiAvatar } from '@/components/axi/AxiAvatar'

interface Props {
  children: React.ReactNode
  messageActions?: React.ReactNode | null
  messageId?: string
  initiallyHoveredMessageId?: string
  avatarContainerClassName?: string
  assistantAvatar?: React.ReactNode
  bgColor?: string
}

export const AiAssistantMessageWrapper: FC<Props> = ({
  children,
  messageActions,
  messageId,
  initiallyHoveredMessageId,
  avatarContainerClassName = 'relative rounded-full min-h-8 min-w-8 overflow-hidden bg-white border border-v8-blue',
  assistantAvatar = <AxiAvatar size={32} />,
  bgColor = '#fff', // white
}) => {
  const [isHovered, setIsHovered] = useState<string | undefined>(
    initiallyHoveredMessageId,
  )

  return (
    <div
      key={messageId}
      className="flex items-center justify-start"
      onMouseEnter={() => {
        if (messageId) {
          setIsHovered(messageId)
        }
      }}
      onMouseLeave={() => {
        if (messageId) {
          setIsHovered(undefined)
        }
      }}
    >
      <div className="max-w-full sm:max-w-[90%] flex flex-col sm:flex-row items-start gap-1">
        <div className={avatarContainerClassName}>
          {/* Assistant Avatar */}
          {assistantAvatar}
        </div>
        {/* Message */}
        <div className="relative w-full flex flex-col gap-1">
          <div
            className={`relative px-2.5 py-2 flex flex-col gap-1 text-left rounded-md`}
            style={{ backgroundColor: bgColor }}
          >
            {/* Mobile message teal-like pointer (points UP) */}
            <div
              className={`absolute top-[-6px] left-0 w-0 h-0 border-r-0 border-b-0 border-l-[10px] border-t-[10px] border-t-transparent sm:hidden`}
              style={{ borderLeftColor: bgColor }}
            ></div>
            {/* Desktop message teal-like pointer (points LEFT) */}
            <div
              className="hidden sm:block absolute top-0 left-[-5px] w-0 h-0 border-r-[10px] border-b-[10px] border-l-0 border-t-0 border-b-transparent"
              style={{ borderRightColor: bgColor }}
            ></div>
            {/* Text field */}
            <>{children}</>
          </div>

          {/* Message Actions */}
          {messageActions && (
            <div
              className={`absolute bottom-[-24px] left-0 w-full px-2 flex ${
                isHovered ? '' : 'hidden'
              }`}
            >
              {messageActions}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
